(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-header.js');


'use strict';

const {
  pinLocationAtom,
  locationConfirmedAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  locationNameAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  useEffect,
  useState,
  useRef
} = React;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const BetslipHeader = () => {
  const [pinLocation, setPinLocation] = useAtom(pinLocationAtom);
  const [locationConfirmed, setLocationConfirmed] = useAtom(locationConfirmedAtom);
  const locationName = useAtomValue(locationNameAtom);
  const [displayedName, setDisplayedName] = useState(locationName);
  const [nameVisible, setNameVisible] = useState(true);
  const latRef = useRef(null);
  const lngRef = useRef(null);
  useEffect(() => {
    if (locationName === displayedName) {
      return;
    }
    setNameVisible(false);
    const t = setTimeout(() => {
      setDisplayedName(locationName);
      setNameVisible(true);
    }, 250);
    return () => clearTimeout(t);
  }, [displayedName, locationName]);
  useEffect(() => {
    var _latRef$current, _lngRef$current;
    if (!pinLocation.lat || !pinLocation.lng) {
      return;
    }
    const latObj = {
      value: parseFloat((_latRef$current = latRef.current) === null || _latRef$current === void 0 ? void 0 : _latRef$current.textContent) || 0
    };
    const lngObj = {
      value: parseFloat((_lngRef$current = lngRef.current) === null || _lngRef$current === void 0 ? void 0 : _lngRef$current.textContent) || 0
    };
    gsap.to(latObj, {
      value: pinLocation.lat,
      duration: 0.35,
      onUpdate: () => {
        if (latRef.current) {
          latRef.current.textContent = latObj.value.toFixed(6);
        }
      }
    });
    gsap.to(lngObj, {
      value: pinLocation.lng,
      duration: 0.35,
      onUpdate: () => {
        if (lngRef.current) {
          lngRef.current.textContent = lngObj.value.toFixed(6);
        }
      }
    });
  }, [pinLocation.lat, pinLocation.lng]);
  const handleIconClick = () => {
    setPinLocation({
      lat: null,
      lng: null
    });
    setLocationConfirmed(false);
    setTimeout(() => {
      setDisplayedName('');
    }, 300);
  };
  return React.createElement("div", {
    className: "lp-betslip-header f-content"
  }, !locationConfirmed && React.createElement(IconButton, {
    className: "betslip-close",
    onClick: () => handleIconClick(),
    title: "St\xE4ng ikon"
  }, React.createElement(Icon, {
    icon: "close"
  })), React.createElement("h3", {
    className: "name",
    style: {
      opacity: nameVisible ? 1 : 0
    }
  }, displayedName), React.createElement("p", {
    className: "coords"
  }, React.createElement("span", {
    ref: latRef
  }, typeof pinLocation.lat === 'number' ? pinLocation.lat.toFixed(6) : '00.000000'), "\xB0N,\xA0", React.createElement("span", {
    ref: lngRef
  }, typeof pinLocation.lng === 'number' ? pinLocation.lng.toFixed(6) : '00.000000'), "\xB0E"));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipHeader
});

 })(window);